/** MUI v7 `shape.borderRadius` may be `number | string`; avoid numeric `*`/`/` on it. */
export function scaleBorderRadius(radius: number | string, factor: number): string | number {
  if (typeof radius === 'number') {
    return radius * factor
  }
  return `calc(${radius} * ${factor})`
}

/** Like `scaleBorderRadius` but always a CSS length string (e.g. for template literals that used `${n}px`). */
export function scaleBorderRadiusPx(radius: number | string, factor: number): string {
  const v = scaleBorderRadius(radius, factor)
  return typeof v === 'number' ? `${v}px` : v
}
